import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

/** Current user's effective tier from the same authority used by quotas and Pro. */
export const getMyEffectiveEntitlement = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { resolveEffectiveTierInternal } = await import("@/lib/quota.server");
    return resolveEffectiveTierInternal(supabaseAdmin, context.userId);
  });